import { z } from "zod";

export const validateSchema = () => {
  return z.object({
    cpf: z.string().min(1),
    agreement_id: z.string().optional().nullable(),
  });
};

export type ValidateFormValues = z.infer<ReturnType<typeof validateSchema>>;
